import { Typography, julo, Button } from '@julo-ui/react';
import { Dialog } from '@new-components/elements';
import { DocumentIcon } from '@new-components/shapes';
import { dialogCss } from './styles';

interface TermConditionProps {
  isOpen: boolean;
  onClose: () => void;
}

const TermCondition = ({ isOpen, onClose }: TermConditionProps) => {
  return (
    <Dialog isOpen={isOpen} onClose={onClose} className={dialogCss}>
      <julo.div className='modal'>
        <julo.div className='header'>
          <DocumentIcon />
          <Typography type='body' bold color='var(--colors-primary-30)'>
            Syarat & Ketentuan
          </Typography>
        </julo.div>
        <julo.div className='content'>
          <Typography type='body' size='small'>
            Anda akan menggunakan layanan PT Privy Identitas Digital termasuk
            namun tidak terbatas pada layanan tanda tangan elektronik dan
            penerbitan sertifikat elektronik yang disediakan oleh PT Privy
            Identitas Digital.
          </Typography>
          <Typography type='body' size='small'>
            PT Julo Teknologi Finansial bekerja sama dengan PT Privy Identitas
            Digital selaku Penyelenggara Tanda Tangan Elektronik tersertifikasi
            dan Penyelenggara Sertifikasi Elektronik yang berinduk pada
            Kementerian Komunikasi dan Informatika Republik Indonesia dengan
            merek Privy.
          </Typography>
          <Typography type='body' size='small'>
            Anda menyatakan setuju untuk mendaftar sebagai pengguna Privy untuk
            menggunakan layanan PT Privy Identitas Digital termasuk namun tidak
            terbatas pada tanda tangan elektronik dan penerbitan sertifikat
            elektronik oleh PT Privy Identitas Digital.
          </Typography>
          <Typography type='body' size='small'>
            Anda memberi kuasa kepada PT Julo Teknologi Finansial untuk
            meneruskan data KTP, swafoto, nomor ponsel dan alamat surel Anda
            sebagai data pendaftaran kepada PT Privy Identitas Digital guna
            memenuhi ketentuan Peraturan Perundang-undangan, yaitu Peraturan
            Pemerintah Nomor 71 Tahun 2019 tentang Penyelenggaraan Sistem dan
            Transaksi Elektronik, dan Peraturan Kementerian Informasi dan
            Komunikasi Nomor 11 Tahun 2022 tentang Tata Kelola Penyelenggaraan
            Sertifikasi Elektronik.
          </Typography>
          <Typography type='body' size='small'>
            Sehubungan dengan penggunaan  penandatanganan secara elektronik oleh
            Anda, Anda setuju untuk memberikan instruksi dan kuasa penuh kepada
            PT Privy Identitas Digital untuk melakukan pembubuhan Tanda Tangan
            Elektronik atas nama Anda pada setiap Dokumen Elektronik yang
            peladen/server Privy terima menggunakan API tertentu dari PT Julo
            Teknologi Finansial sesuai dengan instruksi yang anda berikan,
            dengan menggunakan Data Pembuatan Tanda Tangan Elektronik milik
            Anda.
          </Typography>
          <Typography type='body' size='small'>
            Persetujuan penandatanganan secara elektronik yang saya berikan
            berdasarkan Persetujuan ini berlaku sampai dengan persetujuan
            tersebut saya cabut atau berakhirnya penyediaan layanan PT Privy
            Identitas Digital kepada PT Julo Teknologi Finansial.
          </Typography>
          <Typography type='body' size='small'>
            Dengan ini Anda menyatakan setuju untuk terikat pada syarat dan
            ketentuan layanan Privy yang terdapat pada tautan berikut:{' '}
            <a
              href='https://privy.id/id/pemberitahuan-privasi'
              target='_blank'
              rel='noopener norferrer'
            >
              Pemberitahuan Privasi | Privy
            </a>{' '}
            dan{' '}
            <a
              href='https://privy.id/id/ketentuan-penggunaan'
              target='_blank'
              rel='noopener norferrer'
            >
              {' '}
              Terms of Use | Privy.
            </a>
          </Typography>
          <Typography type='body' size='small'>
            Persetujuan Pengguna ini dapat di anggap sebagai persetujuan yang
            sah sesuai dengan peraturan perundang-undangan yang berlaku.
          </Typography>
        </julo.div>
        <Button block onClick={onClose}>
          Tutup
        </Button>
      </julo.div>
    </Dialog>
  );
};

export default TermCondition;
